import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-paygreen-restoflash',
  templateUrl: './payment-panel-paygreen-restoflash.component.html',
})
export class PaymentPanelPaygreenRestoflashComponent {}
